import { Donation } from '../model/donation';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiStartSessionRequest } from '../model/api-start-session-request';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { APP_BASE_HREF } from '@angular/common';

@Injectable()
export class PaymentService {
  private adyenFacadeUrl: string;

  constructor(private readonly http: HttpClient,
              @Inject(APP_BASE_HREF) private readonly baseHref: string) {
    this.adyenFacadeUrl = environment.ADYEN_FACADE_URL;
  }

  public startAdyenSession(donation: Donation): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const startSessionRequest = {} as ApiStartSessionRequest;
    startSessionRequest.payment = donation.payment;
    startSessionRequest.contact = donation.contact;

    if (environment.ADYEN_RETURN_URL && environment.ADYEN_RETURN_URL !== '') {
      startSessionRequest.returnUrl = environment.ADYEN_RETURN_URL;
    } else {
      startSessionRequest.returnUrl = window.location.origin + this.baseHref + '/result';
    }

    return this.http.post<any>(this.adyenFacadeUrl + '/startSession', startSessionRequest, {headers: headers});
  }

  handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
